import { BackendClient, ClientType } from 'backend-client-web';
import { newUuid } from 'client-core';

let metaCache: Record<string, string | undefined> | undefined;

/** These meta elements are injected into the entry pages by frontend-server. */
function getMeta(name: string) {
  if (!metaCache) {
    metaCache = {};
    for (const meta of document.querySelectorAll<HTMLMetaElement>('meta[name]')) {
      metaCache[meta.name] = meta.content;
    }
  }
  return metaCache[name];
}

export function getHeyloginVersion() {
  return getMeta('application-version');
}

/**
 * Where the web app is served from. Its URL can't be derived from this host, so it is configured.
 * Falls back to this origin.
 */
export function getWebappUrl() {
  if (import.meta.env.VITE_FRONTEND_SERVER) {
    return import.meta.env.VITE_FRONTEND_SERVER;
  }
  return getMeta('frontend-server') ?? window.location.origin;
}

/** The share link service is routed to the backend under this app's own host. */
function getBackendUrl() {
  if (import.meta.env.VITE_BACKEND_SERVER) {
    return import.meta.env.VITE_BACKEND_SERVER;
  }
  return getMeta('backend-server') ?? `${window.location.origin}/api/v1`;
}

// No auditlog: the share link service is all this app calls.
export default function getBackendClient() {
  return new BackendClient({
    backendBaseUri: getBackendUrl(),
    clientId: newUuid(),
    clientType: ClientType.WEB,
    clientVersion: getHeyloginVersion(),
    syncSuperUsers: true,
  });
}
